import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PurchaseSuccessComponent } from '@common-standalone/buy-storage/purchase-success/purchase-success.component';
import { OtpVerificationComponent } from '@common-standalone/logins/otp-verification/otp-verification.component';
import { NotSupportedComponent } from '@common-standalone/not-supported/not-supported.component';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { TwoFaModule } from '@modules/helper-modules/two-fa.module';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions, LottieModule } from 'ngx-lottie';
import { GlobalClassInstance } from '../../../core/constants/GlobalClass';
import { LANDING_HEADER_LIST, LANGUAGE_SUPPORT, MOBILE_LANDING_HEADER_LIST, PAGE_TYPE, THEMES } from '../../../core/constants/LandingConstants';
import { UserloginController } from '../../../core/controller/UserLoginController';
import { UserLoginImplementation } from '../../../core/implementation/UserLoginImplementation';
import { GlobalService } from '../../../core/services/global.service';
import { LandingService } from '../../../core/services/landing.service';
import { LocalStorageSvc } from '../../../core/services/localStorage.service';
import { ActiveRepo, UniversalService } from '../../../core/services/universal.service';
import { EventsjcComponent } from '@common-standalone/events/eventsjc/eventsjc.component';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
declare var $: any;


@Component({
  standalone:true,
  selector: 'lib-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
  imports:[DependenciesModule,TwoFaModule,TranslateModule,PurchaseSuccessComponent,LottieModule,NotSupportedComponent,OtpVerificationComponent]
})
export class LandingHeaderComponent implements AfterViewInit, OnInit {
  public headerLinkList = LANDING_HEADER_LIST;
  // public mobileHeaderLinkList = MOBILE_LANDING_HEADER_LIST;
  // public mobileFooterLinkList = MOBILE_LANDING_FOOTER_LIST;
  public headerMoreOptionsList = LANDING_HEADER_LIST
  public langList = LANGUAGE_SUPPORT;
  public isMobile = (window.innerWidth < 991)
  public showMoreOptions:boolean = false;
  userLoginController: UserloginController ;
  loginImplRef:UserLoginImplementation;
  localStorageSvc: LocalStorageSvc;
  jtrUrl: any;
  public userDetails:any = {};

  isHidden = false;
  private lastScrollTop = 0;
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if(this.universalService.isMobileDevice && this.router.url == "/"){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isHidden = scrollTop > this.lastScrollTop;
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  }

  constructor(
    public router: Router,
    public universalService:UniversalService,
    public landingService:LandingService,
    public globalService :GlobalService,
    private cleverTapEventsService :CleverTapEventsService
  ) {
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    var headerList = [];
    if(this.universalService.isMobileDevice){
      headerList = MOBILE_LANDING_HEADER_LIST;
      this.updateHeaderListAccordingToTheFlags(headerList,4)
    }else{
      headerList = LANDING_HEADER_LIST;
      this.updateHeaderListAccordingToTheFlags(headerList,3)
    }

  }
  @Output() TR = new EventEmitter<any>();


  async ngOnInit(): Promise<void> {
    this.jtrUrl = ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME]["jtrUrl"]
    var classRef = this;
    
    this.userLoginController= UserloginController.getInstance(this.globalService);
    this.loginImplRef = this.userLoginController.userLoginImplementation;
    this.checkIfPassPhraseIsValidated();
    if(localStorage.getItem('userPrefLanguage') == undefined){
      localStorage.setItem('userPrefLanguage','en-US');
    }
    if ((classRef.router.url == ('/') || window.location.href.includes('/features') || window.location.href.includes('/signin') || window.location.href.includes('downloadApp')) && localStorage.getItem('userPrefLanguage') !== null) {
      if((localStorage.getItem('oldUserPrefLanguage'))&&(localStorage.getItem('userPrefLanguage') != localStorage.getItem('oldUserPrefLanguage'))){
        this.switchLanguage(localStorage.getItem('oldUserPrefLanguage'),undefined);
      }
    }
    if(classRef.router.url != ('/')&& !window.location.href.includes('/features') && !window.location.href.includes('/signin')){
      this.switchLanguage('en-US',undefined);
    }
    if(window.location.href.indexOf('downloadApp') == -1 && window.location.href.indexOf('spinthewheel') == -1 && window.location.href.indexOf('scratchtowin') == -1){
      setTimeout(()=>{
        let elemnet = document.querySelector('.lang-switch')as any
        if(elemnet){
          elemnet.classList.remove('lang-switch-desktop');
        }
      },500)
    }
    this.landingService.getLocalisationContent(PAGE_TYPE.PAGE_ABOUT).then(function (response) {
      classRef.landingService.landingPageData = response;
      // setTimeout(function(){
        if(classRef.router.url == ('/') || window.location.href.indexOf('features') > -1 || window.location.href.indexOf('signin') > -1) {
          classRef.universalService.showThemeSwitch = false;
          if(classRef.router.url == ('/')){
            classRef.universalService.initTheme();
            classRef.universalService.showThemeSwitch = true;
          }
          classRef.updateSelectedThemeLanguage();
          if(!classRef.universalService.isMobileDevice) classRef.switchThemeBasedVideoContent();
          // if(!classRef.isMobile){
          //   document.getElementById("c").style.opacity = '0';
          // }
        }
      // });
    }, function (error) {
      //
    });
    if(this.localStorageSvc.getRecoverData(false) == "true" && this.localStorageSvc.getRecoverDataError(false) == "true"){
      this.universalService.showRecoverpopUp = false; 
      this.loginImplRef.noMappingFoundModal = true;
      this.universalService.customerTroubleLogin = true;
    }else if(this.localStorageSvc.getRecoverData(false) == "true" && this.localStorageSvc.getRecoverDataError(false) == null){
      this.universalService.showRecoverpopUp = true; 
      this.loginImplRef.noMappingFoundModal = false;
      this.universalService.customerTroubleLogin = true;

    }
  //   if(this.universalService.isWaveEvent == true){
  //     setTimeout(() => {
  //       this.universalService.isWaveEvent = false;   
  //     }, 100);
     
  //  //   return
  //   }
  }

  ngAfterViewInit(): void {
    setTimeout(function () {
      $(".dropdown-menu li a").click(function () {
        var selText = $(this).text();
        $(this).parents('.btn-group').find('.dropdown-toggle').html(selText + ' <span class="caret"></span>');
      });
      $('#themeLanguage').selectpicker();
    }, 1000);
  }

  async switchLanguage(lang: string,clicked) {
    if(this.universalService.isMobileDevice) {
      if(event){
        lang = $(event.currentTarget).eq(0).attr('lang');
        if(lang != undefined && this.universalService.getThemeLanguage() == lang) {
          return;
        }
        if(lang == undefined){
          if(this.router.url == ('/') || window.location.href.includes('/features') || window.location.href.includes('/signin')){ 
            lang = localStorage.getItem('oldUserPrefLanguage') ? localStorage.getItem('oldUserPrefLanguage') : localStorage.getItem('userPrefLanguage')
          }
          else{
            lang = 'en-US';
          }
        }
      }
      else{
        if(this.router.url == ('/')|| window.location.href.includes('/features') || window.location.href.includes('/downloadApp') || window.location.href.includes('/signin')){
          lang = localStorage.getItem('oldUserPrefLanguage') ? localStorage.getItem('oldUserPrefLanguage') : localStorage.getItem('userPrefLanguage')
        }
        else{
          lang = 'en-US';
        }
      }
    }

    this.universalService.translate.use(lang);
    localStorage.setItem('userPrefLanguage', lang);
    this.universalService.setThemeLanguage(lang);
    this.landingService.landingPageData = await this.landingService.getLocalisationContent(PAGE_TYPE.PAGE_ABOUT);
    if(window.location.href.includes('/features')){
      this.landingService.whatsNewData = await this.landingService.getLocalisationContent(PAGE_TYPE.PAGE_WHAT_NEW);
    }
    if(clicked){
      localStorage.setItem('oldUserPrefLanguage',localStorage.getItem('userPrefLanguage'));
    }
  }

  switchThemeAppearance() {
  
    let htmlElem = document.getElementsByTagName('html')[0];
    let themeSwitchElem = document.getElementById('switchThemeAppearance') as HTMLInputElement;
    if (themeSwitchElem?.checked) {
      this.universalService.setThemeAppearance(THEMES.THEME_DARK);
      htmlElem.setAttribute("data-theme", this.universalService.getThemeAppearance());
      $("#rotateIphoneVideo").css({'transition': 'all ease .3s'});
      localStorage.setItem('userPrefAppearance', this.universalService.getThemeAppearance());
      this.universalService.isDarkTheme = true;
    } else {
      this.universalService.setThemeAppearance(THEMES.THEME_LIGHT);
      htmlElem.setAttribute("data-theme", this.universalService.getThemeAppearance());
      $("#rotateIphoneVideo").css({'transition': 'all ease .3s'});
      localStorage.setItem('userPrefAppearance', this.universalService.getThemeAppearance());
      this.universalService.isDarkTheme = false;
    }
    // if(!this.universalService.isMobileDevice) this.switchThemeBasedVideoContent();
  }

  switchThemeBasedVideoContent() {
    setTimeout(()=>{
      let themeSwitchElem = document.getElementById('switchThemeAppearance') as HTMLInputElement;
      if (themeSwitchElem?.checked || this.landingService.isDarkTheme) {
        this.landingService.isDarkTheme = true;
      }else{
        this.landingService.isDarkTheme = false;
      }
      $("#rotateIphoneVideo").css({'transition': 'all ease .3s'});
    },200)
  }

  openMobileMenuOptions() {
    $('.m-drawer-main').css({ "top": "0", "transition": "all ease-in-out .4s" });
    $('#drawer-overlay').css({ "top": "0", "visibility": "visible", "opacity": ".6", "transition": "all ease-in-out .5s" });
    $('html').css({ "overflow": "hidden" });
  }

  closeMobileMenuOptions()
  {
    $('.m-drawer-main').css({ "top": "-100vh", "transition": "all ease-in-out .4s" });
    $('#drawer-overlay').css({ "visibility": "hidden", "opacity": "0", "transition": "all ease-in-out .5s" });
    $('html').css({ "overflow": "auto" });
  }

  clickOutsideTheDrawer() {
    $('.m-drawer-main').css({ "top": "-100vh", "transition": "all ease-in-out .4s" });
    $('#drawer-overlay').css({ "visibility": "hidden", "opacity": "0", "transition": "all ease-in-out .5s" });
    $('html').css({ "overflow": "auto" });
  }

  updateSelectedThemeLanguage() {
    let currentLang = this.universalService.getThemeLanguage();
    setTimeout(function() {
      let element = document.getElementById('themeLanguage') as HTMLSelectElement;
      element.value = currentLang;
    });
  }

  openLogin() {    
    // document.body.classList.add('modal-open');
    this.cleverTapEventsService.landingPageViewedLoginBtnClicked();
    // this.lazyInjectorService.lazyInjectCss('global', this.renderer2);
    this.router.navigate(['/signin']);
  }

  goToTop(){
    this.landingService.isAnimationOn = false;
    let classRef = this;
    window.scrollTo({top:0,left:0,behavior: 'smooth'});
    let t1 = setInterval(function(){
      if(window.pageYOffset == 0){
        classRef.landingService.isAnimationOn = true;
        classRef.TR.emit(true);
        clearInterval(t1);
      }
    },1300)
    // document.getElementById("go-to-top").style.opacity = '0';
  }

  redirectToRespectivePages(listItem){
    this.showMoreOptions = false;
    this.universalService.planPurchaseInitiated = false;
    if(listItem["name"]=="downloads" || listItem == "downloads"){
      var url = '/downloadApp';
      window.open(url,'_blank', "noopener, noreferrer");
    }else if(listItem["name"]=="whatsNew"){
      this.closeMobileMenuOptions();
      $('html').css({ "overflow": "" });
      $('html').css({ "scroll-behavior": "auto" });
      // this.router.navigate(['/features']);
      window.location.href = '/features';
    }else if(listItem == 'pricing' || listItem["name"]=="pricing"){
      this.closeMobileMenuOptions();
      $('html').css({ "overflow": "" });
      $('html').css({ "scroll-behavior": "auto" });
      if(this.universalService.activeRepo == ActiveRepo.MAIN){
        this.router.navigate(['/pricing']);
      }else{
        window.location.href = '/features';
      }
    }else if(listItem == 'FAQ' || listItem["name"]=="FAQ"){
      var faqLink = '/help';
      window.open(faqLink, "_blank", "noopener, noreferrer");
    }else if(listItem == 'JioTransfer' || listItem["name"]=="JioTransfer"){
      this.cleverTapEventsService.jtrClick();
      this.goToJioTransfer();
    }else if(listItem["name"]== 'enterprise'){
      window.location.href = '/enterprise/about';
    }else if(listItem["name"]== 'home'){
      this.logoRedirection();
    }
    else{
      window.open(listItem["link"],listItem["target"], "noopener, noreferrer");
    }
    this.closeMobileMenuOptions();
  }
  goToJioTransfer(){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["jtrUrl"];
    window.open(url,'_blank', "noopener, noreferrer");
  }

  
  async loggedInRedirection(url){
    $('html').css({ "scroll-behavior": "auto" });
    var checkLogin =localStorage.jio;
    if(checkLogin){
      this.universalService.userLoggedIn = true
    }else{
      this.universalService.userLoggedIn = false
      this.universalService.userLandingLoggedIn = false;
    }
    if(url == 'about') {
      this.closeMobileMenuOptions();
      if(this.universalService.userLoggedIn){
        this.router.navigate(['/home']);
      }else{
        this.router.navigate(['/']);
      }
    } else if(this.universalService.userLandingLoggedIn){
      await this.chech2FAValidationStatus(url);
    }
   } 
   
   pingBeforeRedirection(){
    let serviceUrl=  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["ping"];//
		this.loginImplRef.ping(serviceUrl);
  }

  async chech2FAValidationStatus(route){
    let twoFAEnabled = this.localStorageSvc.getTwoFAEnable(true);
    let status = JSON.parse(localStorage.getItem('passPhraseValidationSuccess'))
    if(twoFAEnabled == 'Y' && (status == null || status == false)){
      this.universalService.show2FApopUp = true
    }else{
      if(route == 'Profile'){
        await this.pingBeforeRedirection();
        if(window.location.href.includes('enterprise/about')|| window.location.href.includes('enterprise/contact-sales')){
          window.location.href = '/userprofile'
        }else{
          this.router.navigate(['userprofile']);
        }
      }
    }
  }

  checkIfPassPhraseIsValidated(){
    let twoFAEnabled = this.localStorageSvc.getTwoFAEnable(true);
    let status = JSON.parse(localStorage.getItem('passPhraseValidationSuccess'));
    let userData = this.localStorageSvc.getUserData(true);
    if((twoFAEnabled == "Y" && (status == null || status == undefined || status == false)) || (userData && userData["isTwoFAEnabled"] && !userData["2FAValidated"])){
      this.universalService.show2FApopUp = true;
    }
  }

  closeModal(){
    this.universalService.purchaseModalType = "";
    this.router.navigate(['/home']);
  }

  showMoreOptionsDropDown(){
    this.showMoreOptions = !this.showMoreOptions;
  }

  loaderoptions: AnimationOptions = {
    path: 'assets/Cloud_bg_2.json',
  };

  options: AnimationOptions = {
    path: 'assets/Cloud_bg_2.json',
  };


  styles: Partial<CSSStyleDeclaration> = {
    maxWidth: '500px',
    margin: '0 auto',
  };

  animationCreated(animationItem: AnimationItem): void {
  }


  updateHeaderListAccordingToTheFlags(listOptions,indexToSplice){
    var findOption;
    var index = -1;
    var userData = this.localStorageSvc.getUserData(true);
    this.userDetails =  userData;
    if(!ENV_CONSTANTS["constants"]["enableJTR"]){
      findOption = listOptions.find(option=>option["name"] == "JioTransfer");
      index = listOptions.indexOf(findOption);
      if(index >=0){
        listOptions.splice(index,1);
      }
    }
    if(!ENV_CONSTANTS["constants"]["enablePricingTab"] || userData && userData["authProviderId"] == ENV_CONFIG["commonUrls"]["jioIdAuthProviderId"]){
      findOption = listOptions.find(option=>option["name"] == "pricing");
      index = listOptions.indexOf(findOption);
      if(index >=0){
        listOptions.splice(index,1);
      }
    }
    this.headerLinkList = listOptions.slice(0,indexToSplice);
    this.headerMoreOptionsList = listOptions.slice(indexToSplice);
    this.universalService.setUpdateProfileIconPath();
  }

  closeDownTimeBanner(){
    this.universalService.showDownTimeBanner = false;
  }
  logoRedirection(){
    this.router.navigate(['/home']);
  }
}
